import React from 'react';
import { AccountSettings } from '@/features/my-account';

const MyAccount: React.FC = () => {
  return <AccountSettings />;
};

export default MyAccount;

